import { render, staticRenderFns } from "./printer-queue.vue?vue&type=template&id=7213d94c"
import script from "./printer-queue.vue?vue&type=script&lang=js"
export * from "./printer-queue.vue?vue&type=script&lang=js"
import style0 from "./printer-queue.vue?vue&type=style&index=0&id=7213d94c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports